import {api} from '../../../system/api';

export default {
    editShippingPartner: (data) => api.put(`shipping-partners/${data.id}`, data),
    editShippingDomesticPartner: (data) => api.put(`shipping-domestic-partners/${data.id}`, data)
};
